"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const deviceAccess_1 = require("../../hw/deviceAccess");
const operation_1 = require("../../operation");
const ledger_amino_1 = require("@cosmjs/ledger-amino");
const crypto_1 = require("@cosmjs/crypto");
const js_buildTransaction_1 = require("./js-buildTransaction");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const launchpad_1 = require("@cosmjs/launchpad");
const Cosmos_1 = require("./api/Cosmos");
const chain_1 = __importDefault(require("./chain/chain"));
const signOperation = ({ account, deviceId, transaction, }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => rxjs_1.Observable.create(o => {
    let cancelled;
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            const cosmosAPI = new Cosmos_1.CosmosAPI(account.currency.id);
            const { accountNumber, sequence } = yield cosmosAPI.getAccount(account.freshAddress);
            o.next({ type: "device-signature-requested" });
            const { aminoMsgs, protoMsgs } = yield (0, js_buildTransaction_1.buildTransaction)(account, transaction);
            if (!transaction.gas) {
                throw new Error("transaction.gas is missing");
            }
            if (!transaction.fees) {
                throw new Error("transaction.fees is missing");
            }
            const feeToEncode = {
                amount: [
                    {
                        denom: account.currency.units[1].code,
                        amount: transaction.fees.toString(),
                    },
                ],
                gas: transaction.gas.toString(),
            };
            // Note:
            // Cosmos Nano App sign data in Amino way only, not Protobuf.
            // This is a legacy outdated standard and a long-term blocking point.
            const chainId = yield cosmosAPI.getChainId();
            const signDoc = (0, launchpad_1.makeSignDoc)(aminoMsgs, feeToEncode, chainId, transaction.memo || "", accountNumber.toString(), sequence.toString());
            const ledgerSigner = new ledger_amino_1.LedgerSigner(transport, {
                hdPaths: [(0, crypto_1.stringToPath)("m/" + account.freshAddressPath)],
                prefix: (0, chain_1.default)(account.currency.id).prefix,
            });
            const signResponse = yield ledgerSigner.signAmino(account.freshAddress, signDoc);
            const tx_bytes = yield (0, js_buildTransaction_1.postBuildTransaction)(signResponse, protoMsgs);
            const signed = Buffer.from(tx_bytes).toString("hex");
            if (cancelled) {
                return;
            }
            o.next({ type: "device-signature-granted" });
            const hash = ""; // resolved at broadcast time
            const accountId = account.id;
            const fee = transaction.fees || new bignumber_js_1.default(0);
            const extra = {};
            const type = transaction.mode === "undelegate"
                ? "UNDELEGATE"
                : transaction.mode === "delegate"
                    ? "DELEGATE"
                    : transaction.mode === "redelegate"
                        ? "REDELEGATE"
                        : ["claimReward", "claimRewardCompound"].includes(transaction.mode)
                            ? "REWARD"
                            : "OUT";
            const senders = [];
            const recipients = [];
            if (transaction.mode === "send") {
                senders.push(account.freshAddress);
                recipients.push(transaction.recipient);
            }
            if (transaction.mode === "redelegate") {
                Object.assign(extra, {
                    sourceValidator: transaction.sourceValidator,
                });
            }
            if (transaction.mode !== "send") {
                Object.assign(extra, {
                    validators: transaction.validators,
                });
            }
            // build optimistic operation
            const operation = {
                id: (0, operation_1.encodeOperationId)(accountId, hash, type),
                hash,
                type,
                value: type === "REWARD"
                    ? new bignumber_js_1.default(0)
                    : transaction.useAllAmount
                        ? account.spendableBalance
                        : transaction.amount.plus(fee),
                fee,
                extra,
                blockHash: null,
                blockHeight: null,
                senders,
                recipients,
                accountId,
                date: new Date(),
                transactionSequenceNumber: sequence,
            };
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature: signed,
                    expirationDate: null,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
    return () => {
        cancelled = true;
    };
}));
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map